import { render, staticRenderFns } from "./EmptyPanel.vue?vue&type=template&id=38c2936e&"
import script from "./EmptyPanel.vue?vue&type=script&lang=js&"
export * from "./EmptyPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports